import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Flex,
  FormControl,
  Input,
  Radio,
  RadioGroup,
  Text,
  Wrap,
} from "@chakra-ui/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchMessageLog } from "../redux/actions/messageActions";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import MessageLogRow from "./screenComponents/MessageLogRow";
import { formatMobile, formatAUDate, formatAUTime } from "../global-client";

const getLocalDateString = (date = new Date()) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const MessagesSearchScreen = () => {
  const dispatch = useDispatch();
  const { loading, error, messageLog, pagination } = useSelector((state) => state.message);
  const [selectedRow, setSelectedRow] = useState(null);

  const [searchBy, setSearchBy] = useState("toNumber");
  const [searchValue, setSearchValue] = useState("");
  const [dateFrom, setDateFrom] = useState(() => getLocalDateString());
  const [dateTo, setDateTo] = useState(() => getLocalDateString());

  const handleRadioChange = (value) => {
    setSearchBy(value);
    setSearchValue("");
  };

  const handleSearch = () => {
    dispatch(searchMessageLog(searchBy, searchValue, dateFrom, dateTo, 1));
  };

  const paginationButtonClick = (page) => {
    dispatch(searchMessageLog(searchBy, searchValue, dateFrom, dateTo, page));
  };

  const selectMsgRow = (row) => {
    setSelectedRow(row);
  };

  return (
    <Box>
      <Box
        maxW={{ base: "100%", md: "5xl" }}
        mx='auto'
        px={{ base: "2", md: "6", lg: "2" }}
        py={{ base: "2", md: "4", lg: "6" }}
        w={{ base: "95vw", md: "auto" }}
        borderWidth={1}
        borderRadius='md'
        mb={4}
      >
        <FormControl>
          <RadioGroup value={searchBy}>
            <Flex
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 2, md: 4 }}
              justify='center'
              align={{ base: "stretch", md: "center" }}
            >
              <Radio
                w={{ base: "100%", md: "auto" }}
                flex={{ base: "1", md: "1" }}
                minW={{ base: "auto", md: "250px" }}
                mb={{ base: "2", md: "0" }}
                value='toNumber'
                onChange={() => handleRadioChange("toNumber")}
              >
                By To Number
              </Radio>
              <Input
                flex={{ base: "1", md: "4" }}
                type='text'
                placeholder='Enter To Number'
                py={{ base: "2", md: "2" }}
                value={searchBy === "toNumber" ? searchValue : ""}
                onChange={(e) => setSearchValue(e.target.value)}
                onFocus={() => {
                  setSearchValue("");
                  setSearchBy("toNumber");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </Flex>
            <Flex
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 2, md: 4 }}
              justify='center'
              align={{ base: "stretch", md: "center" }}
              mt={{ base: 3, md: 4 }}
            >
              <Radio
                w={{ base: "100%", md: "auto" }}
                flex={{ base: "1", md: "1" }}
                minW={{ base: "auto", md: "250px" }}
                mb={{ base: "2", md: "0" }}
                value='fromNumber'
                onChange={() => handleRadioChange("fromNumber")}
              >
                By From Number
              </Radio>
              <Input
                flex={{ base: "1", md: "4" }}
                type='text'
                placeholder='Enter From Number'
                py={{ base: "2", md: "2" }}
                value={searchBy === "fromNumber" ? searchValue : ""}
                onChange={(e) => setSearchValue(e.target.value)}
                onFocus={() => {
                  setSearchValue("");
                  setSearchBy("fromNumber");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </Flex>
            <Flex
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 2, md: 4 }}
              justify='center'
              align={{ base: "stretch", md: "center" }}
              mt={{ base: 3, md: 4 }}
            >
              <Radio
                w={{ base: "100%", md: "auto" }}
                flex={{ base: "1", md: "1" }}
                minW={{ base: "auto", md: "250px" }}
                mb={{ base: "2", md: "0" }}
                value='jobNumber'
                onChange={() => handleRadioChange("jobNumber")}
              >
                By Job Number
              </Radio>
              <Input
                flex={{ base: "1", md: "4" }}
                type='text'
                placeholder='Enter Job Number'
                py={{ base: "2", md: "2" }}
                value={searchBy === "jobNumber" ? searchValue : ""}
                onChange={(e) => setSearchValue(e.target.value)}
                onFocus={() => {
                  setSearchValue("");
                  setSearchBy("jobNumber");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </Flex>
            <Flex
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 2, md: 4 }}
              justify='center'
              align={{ base: "stretch", md: "center" }}
              mt={{ base: 3, md: 4 }}
            >
              <Radio
                w={{ base: "100%", md: "auto" }}
                flex={{ base: "1", md: "1" }}
                minW={{ base: "auto", md: "250px" }}
                mb={{ base: "2", md: "0" }}
                value='customerName'
                onChange={() => handleRadioChange("customerName")}
              >
                By Customer Name
              </Radio>
              <Input
                flex={{ base: "1", md: "4" }}
                type='text'
                placeholder='Enter Customer Name (starts with...)'
                py={{ base: "2", md: "2" }}
                value={searchBy === "customerName" ? searchValue : ""}
                onChange={(e) => setSearchValue(e.target.value)}
                onFocus={() => {
                  setSearchValue("");
                  setSearchBy("customerName");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </Flex>
            <Flex
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 2, md: 4 }}
              justify='center'
              align={{ base: "stretch", md: "center" }}
              mt={{ base: 3, md: 4 }}
            >
              <Radio
                w={{ base: "100%", md: "auto" }}
                flex={{ base: "1", md: "1" }}
                minW={{ base: "auto", md: "250px" }}
                mb={{ base: "2", md: "0" }}
                value='dateRange'
                onChange={() => handleRadioChange("dateRange")}
              >
                By Date Range
              </Radio>
              <Flex
                flex={{ base: "1", md: "4" }}
                gap={{ base: 2, md: 4 }}
                align={{ base: "stretch", md: "center" }}
                w={{ base: "100%", md: "auto" }}
              >
                <Flex align='center' gap='2' w='50%'>
                  <Text fontSize='sm' color='gray.500' whiteSpace='nowrap'>
                    From:
                  </Text>
                  <Input
                    type='date'
                    placeholder='Enter Start Date'
                    flex={{ base: "1", md: "auto" }}
                    py={{ base: "2", md: "2" }}
                    value={searchBy === "dateRange" ? dateFrom : ""}
                    onChange={(e) => {
                      const date = e.target.value;
                      if (date) {
                        const localDate = new Date(date);
                        setDateFrom(getLocalDateString(localDate));
                      } else {
                        setDateFrom("");
                      }
                    }}
                    onFocus={() => setSearchBy("dateRange")}
                  />
                </Flex>
                <Flex align='center' gap='2' w='50%'>
                  <Text fontSize='sm' color='gray.500' whiteSpace='nowrap'>
                    To:
                  </Text>
                  <Input
                    type='date'
                    placeholder='Enter End Date'
                    flex={{ base: "1", md: "auto" }}
                    py={{ base: "2", md: "2" }}
                    value={searchBy === "dateRange" ? dateTo : ""}
                    onChange={(e) => {
                      const date = e.target.value;
                      if (date) {
                        const endOfDay = new Date(date);
                        endOfDay.setHours(23, 59, 59, 999);
                        setDateTo(getLocalDateString(endOfDay));
                      } else {
                        setDateTo("");
                      }
                    }}
                    onFocus={() => setSearchBy("dateRange")}
                  />
                </Flex>
              </Flex>
            </Flex>
          </RadioGroup>
          <Flex justify='center' mt={6}>
            <Button
              colorScheme='blue'
              justifySelf='center'
              onClick={handleSearch}
              isLoading={loading}
              isDisabled={
                (searchBy !== "dateRange" && !searchValue) || (searchBy === "dateRange" && (!dateFrom || !dateTo))
              }
            >
              Search
            </Button>
          </Flex>
        </FormControl>
        <Text align='center' mt={8} fontSize='sm' color='gray.500'>
          {searchBy === "toNumber" && "Searches by To Number will return all messages sent to the specified number."}
          {searchBy === "fromNumber" &&
            "Searches by From Number will return all messages received from the specified number."}
          {searchBy === "jobNumber" &&
            "Searches by Job Number will return all messages associated with the specified job."}
          {searchBy === "customerName" &&
            "Searches by Customer Name will return all messages where the customer's name starts with the entered text."}
          {searchBy === "dateRange" &&
            "Searches by Date Range will return all messages sent or received within the specified dates."}
        </Text>
      </Box>

      {messageLog && messageLog.length >= 1 && (
        <Box p={4}>
          <Wrap spacing='5px' justify='center' minHeight='55vh'>
            {error ? (
              <Alert status='error'>
                <AlertIcon />
                <AlertTitle>We are sorry </AlertTitle>
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            ) : (
              <Box width='100%' p='0' mt='8'>
                <Box overflowX={{ base: "auto", md: "auto" }} w='100%'>
                  <Box w='100%' display='flex' flexDirection='column'>
                    <MessageLogRow
                      key={"header"}
                      id='ID'
                      text='Content'
                      direction='In/Out'
                      toNumber='To Number'
                      fromNumber='From Number'
                      customerName='Customer Name'
                      date='Date'
                      time='Time'
                      index={-1}
                      selected={false}
                      header={true}
                      mt='8'
                    />
                    {messageLog.map((msg, index) => (
                      <MessageLogRow
                        key={msg.SMSLOG_ID}
                        id={msg.SMSLOG_ID}
                        text={msg.TEXT}
                        direction={msg.DIRECTION}
                        toNumber={formatMobile(msg.TO_NUMBER)}
                        fromNumber={formatMobile(msg.FROM_NUMBER)}
                        customerName={msg.CUST_FNAME + " " + msg.CUST_SNAME}
                        date={msg.DT_STAMP && formatAUDate(msg.DT_STAMP, { weekday: false })}
                        time={msg.DT_STAMP && formatAUTime(msg.DT_STAMP)}
                        index={index}
                        selected={selectedRow === index}
                        header={false}
                        onSelect={(row) => {
                          selectMsgRow(row);
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              </Box>
            )}
          </Wrap>

          <Wrap spacing='10px' justify='center' p='5'>
            <Button
              colorScheme='cyan'
              onClick={() => paginationButtonClick(Math.max(1, pagination.currentPage - 1))}
              isDisabled={pagination.currentPage === 1}
            >
              <ArrowLeftIcon />
            </Button>
            {(() => {
              const pages = [];
              const { currentPage, totalPages } = pagination;
              // Always show first 2 pages
              for (let i = 1; i <= Math.min(2, totalPages); i++) {
                pages.push(
                  <Button
                    colorScheme={currentPage === i ? "cyan" : "gray"}
                    onClick={() => paginationButtonClick(i)}
                    key={i}
                  >
                    {i}
                  </Button>
                );
              }
              // Show "..." if there are more than 4 pages and currentPage > 3
              if (totalPages > 4 && currentPage > 3) {
                pages.push(
                  <Box key='start-ellipsis' px={2}>
                    ...
                  </Box>
                );
              }
              // Show current page if it's not in first 2 or last page
              if (currentPage > 2 && currentPage < totalPages) {
                pages.push(
                  <Button colorScheme='cyan' onClick={() => paginationButtonClick(currentPage)} key={currentPage}>
                    {currentPage}
                  </Button>
                );
              }
              // Show "..." if there are more than 4 pages and currentPage < totalPages - 1
              if (totalPages > 4 && currentPage < totalPages - 1) {
                pages.push(
                  <Box key='end-ellipsis' px={2}>
                    ...
                  </Box>
                );
              }
              // Always show last page if totalPages > 2
              if (totalPages > 2) {
                pages.push(
                  <Button
                    colorScheme={currentPage === totalPages ? "cyan" : "gray"}
                    onClick={() => paginationButtonClick(totalPages)}
                    key={totalPages}
                  >
                    {totalPages}
                  </Button>
                );
              }
              return pages;
            })()}
            <Button
              colorScheme='cyan'
              onClick={() => paginationButtonClick(Math.min(pagination.totalPages, pagination.currentPage + 1))}
              isDisabled={pagination.currentPage === pagination.totalPages}
            >
              <ArrowRightIcon />
            </Button>
          </Wrap>
        </Box>
      )}

      {messageLog && messageLog.length === 0 && !loading && (
        <Box textAlign='center' py={10}>
          <Text fontSize='lg' color='gray.500'>
            No messages found. Try adjusting your search criteria.
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default MessagesSearchScreen;
